(function () {
  if (window.wlyVideoReady) return;
  window.wlyVideoReady = true;

  function swap(media, box) {
    box.className = media.className + ' is-playing';
    media.parentNode.replaceChild(box, media);
  }

  document.addEventListener('click', function (event) {
    if (!event.target.closest) return;
    var media = event.target.closest('[data-wly-vid-embed], [data-wly-vid-file]');
    if (!media) return;
    var box = document.createElement('div');
    if (media.hasAttribute('data-wly-vid-file')) {
      var tpl = media.parentNode.querySelector('template[data-wly-vid-tpl]');
      if (!tpl) return;
      event.preventDefault();
      box.appendChild(document.importNode(tpl.content, true));
      swap(media, box);
      var video = box.querySelector('video');
      if (video) {
        video.focus();
        if (video.play) {
          var played = video.play();
          if (played && played['catch']) played['catch'](function () {});
        }
      }
      return;
    }
    var src = media.getAttribute('data-wly-vid-embed');
    if (!src) return;
    event.preventDefault();
    var frame = document.createElement('iframe');
    frame.className = 'wly-vid__frame';
    frame.src = src;
    frame.title = media.getAttribute('data-wly-vid-title') || 'Video';
    frame.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen';
    frame.setAttribute('allowfullscreen', '');
    box.appendChild(frame);
    swap(media, box);
    frame.focus();
  });
})();
